import { paths } from 'src/routes/paths';

export const HOST_API = process.env.NEXT_PUBLIC_HOST_API;

export const ASSETS_API = process.env.NEXT_PUBLIC_ASSETS_API;

export const PATH_AFTER_LOGIN = paths.dashboard.finance.root;

export const LOCAL_STORAGE_TOKEN = 'ACCESS_TOKEN';

export const USER_EMAIL = 'USER_EMAIL';

export const FRANCHISEES = 'FRANCHISEES';

export const SELECTED_FRANCHISEE = 'SELECTED_FRANCHISEE';

export const FRANCHISOR_OF_THE_SELECTED_FRANCHISEE = 'FRANCHISOR_OF_THE_SELECTED_FRANCHISEE';

export const COMPANY_CONTACTS = 'COMPANY_CONTACTS';

export const FINANCE_FILTERS = 'FINANCE_FILTERS';
